import { notifications } from '@mantine/notifications';
const lastShown = {};
function shouldShow(key, cooldownMs = 8000) {
    const now = Date.now();
    const last = lastShown[key] || 0;
    if (now - last < cooldownMs)
        return false;
    lastShown[key] = now;
    return true;
}
export function notifyNetworkError(key, opts) {
    if (!shouldShow(key))
        return;
    notifications.show({
        color: opts.color || 'red',
        title: opts.title || '网络异常',
        message: opts.message || '请检查网络连接或稍后重试',
        withCloseButton: true,
        autoClose: opts.sticky ? false : 5000,
    });
}
export function notifyInfo(key, opts) {
    if (!shouldShow(key, 2000))
        return;
    notifications.show({
        color: opts.color || 'blue',
        title: opts.title || '提示',
        message: opts.message || '',
        withCloseButton: true,
        autoClose: opts.autoCloseMs ?? 3000,
    });
}
